module.exports = __webpack_public_path__ + "c55c2fd3bd15246eb61e6972f72ea828.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/megaphone.png
// module id = 3022
// module chunks = 0